import Vue from 'vue'
import '@webpros/three-sixty-contentscreen'

Vue.config.ignoredElements = [
  'tsx-contentscreen',
  'tsx-contentscreen-trigger'
]
